import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api-client"
import type { MentionEntity } from "@/lib/ag-ui-types"

interface MentionsResponse {
  results: MentionEntity[]
}

export function useAiMentions(query: string, types?: string[]) {
  return useQuery({
    queryKey: ["ai_mentions", query, types],
    queryFn: () => {
      const params = new URLSearchParams({ q: query })
      if (types?.length) {
        types.forEach((t) => params.append("types[]", t))
      }
      return api.get<MentionsResponse>(`/api/v1/ai/mentions?${params}`)
    },
    enabled: query.length >= 2,
    staleTime: 30_000,
  })
}
